'use strict';

const BasePresenter = require('./base');

class SectionPresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    return {
      discountEnabled: this.model.getDiscountEnabled(),
      price: this.model.getFormattedPrice(),
      selected: (this.options.selected && this.options.selected.getTitle() === this.model.getTitle()) || false,
      title: this.model.getTitle(),
      value: this.model.getFormattedValue(),
    };
  }
}

module.exports = SectionPresenter;
